import React, { useState } from 'react';
import { Link, useParams  } from 'react-router-dom'  
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { Row,Col,Container,Button } from 'react-bootstrap';  
import { BsDownload } from "react-icons/bs";
import { MdArrowBack } from "react-icons/md";

import { DOWNLOAD_URL } from '../utils/constants';
import '../css/view.css';  

const ViewComponent = () => {
	let { link, finyear } = useParams();
	const [numPages, setNumPages] = useState(null);
	
	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages( numPages);
	};

	const onLoadError = () => {
		alert('Error in loading document!!');
	}

	var pageArray = [];
	for(var c=1;c <= numPages;c++)
		pageArray.push(c);
	return (
		<div className="pdfNavigator">
			<Container>
				<nav className="top-sticky">
					<Row className="text-center">
						<Col className="col-6">
							<h6>
							<Link to="/main">
								<Button>
									<span className='wlink'><MdArrowBack/> &nbsp; Back to main</span>
								</Button>
							</Link>
							</h6>
						</Col>
						<Col>
							<h6>
							<a href={`${DOWNLOAD_URL}/${finyear}/${link}`} download>
								<Button>
									<span className='wlink'><BsDownload/> &nbsp; Download pdf</span>
								</Button>
							</a>W
							</h6>
						</Col>
					</Row>
				</nav>
			</Container>

			<Document
				file={`/files/${finyear}/${link}`}
				onLoadSuccess={onDocumentLoadSuccess}
				loading={<div class="simple-shape two"></div>}
				onLoadError={onLoadError}
				>
				{pageArray.map(page => (
					<Page pageNumber={page} key={page} width={1024} loading="Loading Page..."/>
				))}
			</Document>
		</div>
	)

}
export default ViewComponent
